/* Hero lens cursor (§10.1, §13, optional). A ring follows the mouse over [data-lens] sections, grows
   over links and becomes a brass "View" disc over a hotspot. The real cursor stays visible — this is
   an extra layer, never a replacement. Mouse with a fine pointer only; nothing with reduced motion. */
(() => {
  const theme = window.Theme;
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  if (!theme || !fine.matches) return;

  function attach(root) {
    if (root.querySelector(':scope > .lens')) return;
    const lens = document.createElement('span');
    lens.className = 'lens';
    lens.setAttribute('aria-hidden', 'true');
    const label = document.createElement('span');
    label.className = 'lens__label';
    label.textContent = root.dataset.lens || '';
    lens.append(label);
    root.append(lens);

    let frame = 0;
    let point = null;
    const render = () => {
      frame = 0;
      if (!point) return;
      const rect = root.getBoundingClientRect();
      lens.style.translate = `${(point.x - rect.left).toFixed(1)}px ${(point.y - rect.top).toFixed(1)}px`;
      lens.classList.toggle('is-spot', Boolean(point.target.closest('[data-spot-trigger], .spot__tag')));
      lens.classList.toggle('is-link', !lens.classList.contains('is-spot') && Boolean(point.target.closest('a, button')));
    };

    root.addEventListener('pointermove', (event) => {
      if (event.pointerType !== 'mouse' || !theme.motionAllowed()) return;
      point = { x: event.clientX, y: event.clientY, target: event.target };
      lens.classList.add('is-visible');
      if (!frame) frame = requestAnimationFrame(render);
    }, { passive: true });
    root.addEventListener('pointerleave', () => lens.classList.remove('is-visible'));
  }

  const scan = (scope) => scope.querySelectorAll('[data-lens]').forEach(attach);
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
